import React from "react";
import {
  TopClientsByVolumeRootBox,
  TopClientsByVolumeInnerBox,
  SemiBoldText,
  HelperText,
  SalesAnalyticsOverflowBox,
  SalesAnalyticsContentBox,
  SalesAnalyticsCardLabel,
  StyledSalesAnalyticsCard,
  ProductWodCurrentFlexBox,
  headerRightStyles,
} from "../../pages/selller/dashboards/styles";
import colors from "../../theme/Colours";

interface ListItem {
  title: string;
  subtitle?: string;
  rightTop: string;
  rightTopColor?: string;
  rightBottom?: string;
  rightBottomColor?: string;
  backgroundColor?: string;
  helperText?: string;
  isPositive?: boolean | null;
  border?: string;
}

interface DashboardListCardProps {
  title: string;
  items: ListItem[];
  headerRight?: React.ReactNode;
  height?: string;
}

export default function DashboardListCard({
  title,
  items,
  headerRight,
  height,
}: DashboardListCardProps) {
  const renderBottomRow = (item: ListItem) => {
    if (!item.subtitle && !item.rightBottom) return null;

    return (
      <TopClientsByVolumeInnerBox>
        <HelperText>{item.subtitle}</HelperText>

        {item.rightBottom ? (
          <SemiBoldText
            sx={{
              color:
                item.rightBottomColor ?? colors.salesAnalyticsCardHelperText,
            }}
          >
            {item.rightBottom}
          </SemiBoldText>
        ) : (
          <HelperText />
        )}
      </TopClientsByVolumeInnerBox>
    );
  };

  const renderHelperText = (item: ListItem) => {
    if (!item.helperText) return null;

    let textColor;
    if (item.isPositive === true) {
      textColor = colors.progressColorKpi;
    } else if (item.isPositive === false) {
      textColor = colors.regressColorKpi;
    } else {
      textColor = colors.salesAnalyticsCardHelperText;
    }

    return (
      <TopClientsByVolumeInnerBox>
        <div></div>
        <HelperText
          style={{
            color: textColor,
          }}
        >
          {item.helperText}
        </HelperText>
      </TopClientsByVolumeInnerBox>
    );
  };

  const renderItem = (item: ListItem, index: number) => {
    const hasComparison = !!item.helperText;

    return (
      <TopClientsByVolumeRootBox
        key={`${item.title}-${index}`}
        bgcolor={item.backgroundColor}
        hasComparison={hasComparison}
        style={{ border: item.border }}
      >
        <TopClientsByVolumeInnerBox>
          <SemiBoldText sx={{ fontSize: "14px" }}>{item.title}</SemiBoldText>
          <SemiBoldText sx={{ color: item.rightTopColor }}>
            {item.rightTop}
          </SemiBoldText>
        </TopClientsByVolumeInnerBox>

        {renderBottomRow(item)}
        {renderHelperText(item)}
      </TopClientsByVolumeRootBox>
    );
  };

  return (
    <StyledSalesAnalyticsCard sx={height ? { height } : undefined}>
      <TopClientsByVolumeInnerBox style={headerRightStyles}>
        <SalesAnalyticsCardLabel>{title}</SalesAnalyticsCardLabel>
        {headerRight ? <div>{headerRight}</div> : null}
      </TopClientsByVolumeInnerBox>

      <SalesAnalyticsContentBox>
        <SalesAnalyticsOverflowBox>
          <ProductWodCurrentFlexBox>
            {items.map(renderItem)}
          </ProductWodCurrentFlexBox>
        </SalesAnalyticsOverflowBox>
      </SalesAnalyticsContentBox>
    </StyledSalesAnalyticsCard>
  );
}
